import BaseUseCase from "../../../base_use_case.js";
import Routes from "../../../../admin/routes.js";
class ListMenusUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/frontend/mainmenu`,
      params: params
    }).then((result) => {
      let { data, headers } = result;
      let { pages } = data;

      pages = pages.map((menu) => {
        return {
          ...menu,
          id: menu.slug,
          key: menu.slug,
          itemLink: Routes.page(menu)
        }
      })
      data.list = pages;
      return { data, headers }
    })
  }
}

const instance = new ListMenusUseCase();
export default instance;
